import { put, get } from '@client/lib/request';
import { setSubscriptionHiddenCookie } from '@client/helpers/subscription-cookie';

export type NewsletterTarget = {
    saleschannel: string;
    locale: string;
};

export const subscribeToNewsletter = ({ saleschannel, locale }: NewsletterTarget): Promise<void> =>
    put(
        '/api/phoenix/customer/preferences/newsletters',
        {
            daily: true,
        },
        null,
        {
            params: {
                saleschannel,
                locale,
            },
        },
    ).then(() => {
        setSubscriptionHiddenCookie();
    });

export const fetchSubscriptions = ({ saleschannel, locale }: NewsletterTarget) =>
    get('/api/phoenix/customer/preferences/newsletters', {
        saleschannel,
        locale,
    });

export const fetchConsentStatus = () => get('/api/phoenix/customer/consents/newsletter');
